export default {
  edit: {
    attributes: [
      {attribute: "name", translated: true},
      {attribute: "email"},
      {attribute: "principalName"}
    ]
  },
  table: {
    columns: () => [
      {
        attribute: "name",
        sortKey: "currentTranslationName"
      },
      {
        attribute: "schoolClassesCount",
        sortKey: "schoolClassesCount"
      },
      {
        attribute: "institutionNumber",
        sortKey: "institutionNumber"
      },
      {
        attribute: "createdAt",
        sortKey: "createdAt"
      }
    ]
  }
}
